<template>
  <div class="px-3">
    <h3>Comments</h3>
    <div v-if="feedback.length > 0">
      <div v-for="feedback in feedback" :key="feedback.id" class="mb-4">
        <div class="flex flex-row">
          <d-avatar :text="feedback.userFullName" :img-src="feedback.userProfileImage" class="px-4 flex-none" size="50px" />
          <div class="px-4">
            <div class="wysiwyg-editor-container" v-html="feedback.comment" />
            <p class="text-gray-600 text-sm">
              {{ feedback.userFullName }} &bull; {{ feedback.createdAt | formatShortDateTime }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div v-if="loading" class="py-10 text-center">
      <d-loader />
    </div>
    <form class="pt-5" @submit.prevent="submitFeedback()">
      <d-field label="Add a New Comment">
        <vue-editor v-model="feedbackForm.comment" placeholder="Begin typing your comment here..." type="textarea" class="text-3xl rounded-md bg-white border-gray-300 shadow-md mb-5" :editor-toolbar="customToolbar" />
      </d-field>
      <div class="flex justify-end">
        <d-button :loading="saving" type="submit">
          Post Reply
        </d-button>
      </div>
    </form>
  </div>
</template>

<script>
  import axios from 'axios';

  export default {
    props: {
      userId: {
        type: String,
        default: () => '',
      },
      entityId: {
        type: Number,
        default: () => 0,
      },
      type: {
        type: String,
        default: () => '',
      },
    },

    data: () => ({
      feedback: [],
      saving: false,
      loading: false,
      feedbackForm: {
        userId: '',
        userAssignmentId: 0,
        userToDoItemId: 0,
        comment: '',
      },
      customToolbar: [
        ['bold', 'italic', 'underline', 'strike'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ color: [] }], ['clean'],
        ['link'],
      ],
    }),

    mounted() {
      this.getFeedback();
    },

    methods: {
      async submitFeedback() {
        this.saving = true;
        try {
          this.feedbackForm.userId = this.userId;
          this.feedbackForm.userAssignmentId = this.entityId;
          this.feedbackForm.userToDoItemId = this.entityId;

          if (this.type === 'Assignment') {
            await axios.post('/api/assignments/feedback', this.feedbackForm);
          } else {
            await axios.post('/api/assignments/todos/feedback', this.feedbackForm);
          }

          this.getFeedback();
          this.feedbackForm.comment = '';
          this.$parent.events.getFeedback();
        } catch (error) {
          this.$toast.error(error.message.data);
        } finally {
          this.saving = false;
        }
      },

      async getFeedback() {
        this.loading = true;
        try {
          if (this.type === 'Assignment') {
            const { data } = await axios.get(`/api/assignments/${this.entityId}/feedback`);
            this.feedback = data;
          } else {
            const { data } = await axios.get(`/api/assignments/todos/${this.entityId}/feedback`);
            this.feedback = data;
          }
          this.loading = false;
        } catch (error) {
          this.$toast.error(error.message.data);
        } finally {
          this.loading = false;
        }
      },
    },
  };
</script>